__turbopack_context__.v({
  "container": "ExpertCard-module-scss-module__Ttlcfq__container",
  "expertise": "ExpertCard-module-scss-module__Ttlcfq__expertise",
  "name": "ExpertCard-module-scss-module__Ttlcfq__name",
});
